(ns manage.content-configuration-page.context-source.automatic-split-testing
  (:require [manage.content-configuration-page.context-source.shared :as cs]
            [re-posh.core :as rp]))

(def schema-id "urn:lemonpi:schema:context:split-testing:v1")

;; database

(rp/reg-query-sub ::arms
  '[:find [?v ...]
    :in $ ?c
    :where
    [?c :context-source/macro ?p]
    [?p :macro/selector [:arm]]
    [?p :predicate/value ?v]])

(defmethod cs/parameter schema-id
  [{:context-source/keys [alias]}]
  ;; contains subscriptions inside a function that is also called by an event handler
  ;; re-frame does not like that, potential issue
  {:adset-id (js/parseInt (:adset-id @(rp/subscribe [:context])))
   :arms @(rp/subscribe [::arms [:context-source/alias alias]])})

;; we completely ignore the param when importing this context source
(defmethod cs/context->constructor schema-id [_])
